import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AxiaTransfRequest, UploadedEvidence } from 'src/app/model/agendas';
import { environment } from 'src/environments/environment';
import { AuthService } from '../AuthService/auth-service.service';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  uploadedEvidence:UploadedEvidence[];
  currentURL='';
  options:{ headers: HttpHeaders };
  _uploadedEvidence: BehaviorSubject<UploadedEvidence[]>

  public isLoading: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor( private http: HttpClient, private _authService:AuthService) {
    this.currentURL = window.location.origin.includes('localhost')? "": environment.BaseURL;
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'});
      this.options = { headers: headers };

      this._uploadedEvidence= <BehaviorSubject<any>>new BehaviorSubject([])
   }

   get evidenceUpload(){
    return this._uploadedEvidence.asObservable()
  }

   GetAllUploadsData(agentId:string): Observable<UploadedEvidence[]> {
    return this.http.post<UploadedEvidence[]>( this.currentURL + environment.GetAllUploadedEvidence, {agentId:agentId,vabYear:this._authService.getTaxYear()}, this.options).pipe(
      tap((data: UploadedEvidence[]) => {
        this.uploadedEvidence = data;
        this._uploadedEvidence.next(Object.assign([], this.uploadedEvidence));
      })
    );
  }

  ClearAllUploadsData(){
      this.uploadedEvidence =[]
      this._uploadedEvidence.next([]) 
  }

   InsertUploadFile(upload:UploadedEvidence){
    return this.http.post<any>( this.currentURL + environment.insertUploadFile, upload, this.options)
  }

   ExecuteAxiaTransfer(upload:AxiaTransfRequest){
    return this.http.post<any>( this.currentURL + environment.ExecuteAxiaTransfer, upload, this.options)
  }

  multiplyFiles(request: {FilesPath:string[], Agendas:string[]}){
    return this.http.post<any>( this.currentURL + environment.multiplyFiles, request, this.options)
  }

  InsertUploadTransaction(agentCode:number, agendas:{agenda, hearingDate}[]){ 
    return this.http.post<any>( this.currentURL + environment.insertUploadTransaction, {AgentCode: agentCode, AgendasAndHearing:agendas}, this.options)
  }


}